import React from "react";
import PropTypes from "prop-types";

import { JobApplicationsExternalSingle } from "./JobApplicationsExternalSingle";

export const JobApplicationsExternal = props => {
    const { external } = props;

    if (!external) return "";

    return (
        <section className="applications--external">
            <h4 className="h4">My External Applications</h4>
            <div className="application-list__header">
                <p className="p-tag">
                    Sometimes job listings take you to our partner's sites, meaning we're
                    not sure if you applied or not.
          <br />
                    Let us know below so we can better assist you.
        </p>
            </div>
            <div className="table--jobs">
                <div className="table__header visible-md-block visible-lg-block">
                    <div className="row">
                        <div className="col-xs-12 col-md-4">
                            <h5 className="h5 header">Position and Salary</h5>
                        </div>
                        <div className="col-xs-12 col-md-2">
                            <h5 className="h5 header">Closing date</h5>
                        </div>
                        <div className="col-xs-12 col-md-6">
                            <h5 className="h5 header">Update application status</h5>
                        </div>
                    </div>
                </div>
                <div className="table__body">
                    {external.map((application, i) => {
                        return (
                            <JobApplicationsExternalSingle
                                application={application}
                                key={i}
                            />
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

JobApplicationsExternal.propTypes = {
    external: PropTypes.array
};



// WEBPACK FOOTER //
// src/client/components/site/features/jobs/pages/elements/JobApplicationsExternal.js